import SupplierTableFilter from "./supplier-table-filter";

const SupplierFilters = {
  Table: SupplierTableFilter,
};

export default SupplierFilters;
